export default "__VITE_ASSET__9792bb9d__"